import { render } from "./MmProductManage.vue?vue&type=template&id=4f79d6a4"
import script from "./MmProductManage.vue?vue&type=script&lang=js"
export * from "./MmProductManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__